export const enum AnalyticsEvent {
  //InitApplication
  InitApplication = 'InitApplication / User initialized the application',

  //Authentication
  Authentication = 'Authentication',

  //Integrations
  OpenIntegrationsOverview = 'Integrations / Open Integrations Overview',

  //Report
  OpenReport = 'Report / Open report',
  PerformanceReportViewPdf = 'Performance Reports / View PDF',
  PerformanceReportDownloadPdf = 'Performance Reports / Download PDF',
  PerformanceReportFeedback = 'Performance Reports / Send feedback',

  //Demo 
  OpenDemo = 'Demo / Open demo',

  //PowerBI Embed events
  PBIEmbedEvent = 'PowerBIEmbedEvent / Power BI  embed event',

  //Scheduler events
  OpenSchedulerForm = 'Scheduler / Open scheduler form',
  SubmitSchedulerForm = 'Scheduler / Submit scheduler form',
  CancelSchedulerForm = 'Scheduler / Cancel scheduler form',
  SchedulerBlocked = 'Scheduler / Scheduler creation blocked',
  OpenLeadForm = 'Scheduler / Open lead form',
  SubmitLeadForm = 'Scheduler / Submit lead form',
  CancelLeadForm = 'Scheduler / Cancel lead form',
}
export type AnalyticsProperties = Record<string, unknown>
